import { createSlice } from '@reduxjs/toolkit'


export const defaultActivityReducerState = {
    isLoading: false,
    operationType: '',
    editActivity: null,
    adminActivityChannel: null,
    userActivityChans: [],
    publicTimelineChan: null,
    activityList: [],
    liked: undefined,
    commentLoading: false,
    comments: [],
    refetchComments: false,
    packageAndCenters: {},
    lastInverseDate: undefined,
    isEnd: undefined,
    activityChannels: {},
    activityListIds: []
}

const initialState = defaultActivityReducerState;


export const activitySlice = createSlice({
    name: 'activity',
    initialState: { ...initialState },
    reducers: {
        activitySagaSuccess: (state, action) => {
            if (action.payload) {
                Object.assign(state, action.payload);
            }
        },
        activitySagaFailed: (state, action) => {
            state.operationType = '';
            state.isLoading = false;
            state.commentLoading = false;
        },
        resetActivityOperationType: (state, action) => {
            state.operationType = '';
            state.isLoading = false;
        },
        resetActivityReducer: (state, action) => {
            if (action.payload) {
                Object.assign(state, action.payload);
            }
        },
        createActivity: (state, action) => {
            state.isLoading = true;
        },
        uploadActivityMedia: (state, action) => { },
        deleteActivityPost: (state, action) => {
            state.isLoading = true;
        },
        activeInactiveActivity: (state, action) => {
            state.isLoading = true;
        },
        updateActivity: (state, action) => {
            state.isLoading = true;
        },
        getActivityForEdit: (state, action) => {
            state.editActivity = null
            state.isLoading = true;
        },
        resetOperationType: (state, action) => {
            state.operationType = ""
        },
        getAllAdminActivities: (state, action) => {
            state.isLoading = true;
        },
        getAllListingActivities: (state, action) => {
            state.isLoading = true;
        },
        getGuestActivities: (state, action) => {
            state.isLoading = true;
        },
        likeActivity: (state, action) => {
            // state.isLoading = true;
        },
        likeActivityComment: (state, action) => {
            state.commentLoading = true;
        },
        postActivityComment: (state, action) => {
            state.commentLoading = true;
        },
        postCommentReply: (state, action) => {
            state.commentLoading = true;
        },
        updateActivityComment: (state, action) => {
            state.commentLoading = true;
        },
        deleteActivityComment: (state, action) => {
            state.commentLoading = true;
        },
        updateCommentReply: (state, action) => {
            state.commentLoading = true;
        },
        deleteCommentReply: (state, action) => {
            state.commentLoading = true;
        },
        getActivityComment: (state, action) => {
            state.commentLoading = true;
            state.refetchComments = false;
            // state.comments = [];
        },
        getPackageAndCentersOfAccounts: (state, action) => {
        },
        getActivityType: (state, action) => {
        },
        insertActivities: (state, action) => {
            state.isLoading = false
            state.activityList = [...state.activityList, ...action.payload.activityList];
            state.lastInverseDate = action.payload.lastInverseDate;
            state.isEnd = action.payload.isEnd;
        },
        watchSingleActivity: (state, action) => { },
        updateActivityById: (state, action) => {
            const { activityId, post, chan } = action.payload;
            const newActivityChannels = { ...state.activityChannels };
            newActivityChannels[activityId] = chan;
            let timeline = [...state.activityList]
            const idx = timeline.findIndex(act => act.id === activityId);
            if (idx !== -1) timeline[idx] = post;
            else timeline.push(post);
            timeline = timeline.filter(a => a && state.activityListIds.includes(a.id)).sort((a, b) => a.inverseDate - b.inverseDate);
            return {
                ...state,
                activityChannels: { ...newActivityChannels },
                activityList: timeline,
            };
        }
    },
})


export const {
    activitySagaSuccess,
    activitySagaFailed,
    resetActivityOperationType,
    resetActivityReducer,
    createActivity,
    uploadActivityMedia,
    deleteActivityPost,
    activeInactiveActivity,
    getActivityForEdit,
    updateActivity,
    resetOperationType,
    getAllAdminActivities,
    getAllListingActivities,
    getGuestActivities,
    likeActivity,
    likeActivityComment,
    postActivityComment,
    postCommentReply,
    getActivityComment,
    getPackageAndCentersOfAccounts,
    updateActivityComment,
    deleteActivityComment,
    updateCommentReply,
    deleteCommentReply,
    getActivityType,
    updateActivityById,
    watchSingleActivity
} = activitySlice.actions;


export default activitySlice.reducer;